/** Campos según plantilla Evaluación Inicial Terapia Ocupacional (v2) */

export const TIPO_CAMPO = {
  LINEA: "linea",
  MULTILINEA: "multilinea",
  FECHA: "fecha",
};

export const CAMPOS_DATOS_GENERALES = [
  { key: "nombreApellido", label: "Nombre", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "cedula", label: "Cédula", tipo: TIPO_CAMPO.LINEA, maxLength: 20 },
  { key: "sexo", label: "Sexo", tipo: TIPO_CAMPO.LINEA, maxLength: 15 },
  { key: "fnacimiento", label: "Fecha de nacimiento", tipo: TIPO_CAMPO.FECHA },
  { key: "edadTexto", label: "Edad", tipo: TIPO_CAMPO.LINEA, maxLength: 25 },
  { key: "diagnostico", label: "Diagnóstico", tipo: TIPO_CAMPO.LINEA, maxLength: 100 },
  { key: "nombreMadre", label: "Nombre de la madre", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "ocupacionMadre", label: "Ocupación (madre)", tipo: TIPO_CAMPO.LINEA, maxLength: 60 },
  { key: "nombrePadre", label: "Nombre del padre", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "ocupacionPadre", label: "Ocupación (padre)", tipo: TIPO_CAMPO.LINEA, maxLength: 60 },
  { key: "hermanos", label: "Hermanos", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "colegio", label: "Colegio", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "gradoEscolar", label: "Grado", tipo: TIPO_CAMPO.LINEA, maxLength: 40 },
  { key: "referencia", label: "Referencia", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "condicionSalud", label: "Condición de salud", tipo: TIPO_CAMPO.LINEA, maxLength: 100 },
  { key: "alergias", label: "Alergias", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "medicamentos", label: "Medicamentos", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "fechaInforme", label: "Fecha", tipo: TIPO_CAMPO.FECHA },
  { key: "fechaInicioTerapia", label: "Inicio terapia", tipo: TIPO_CAMPO.FECHA },
];

export const CAMPOS_ANTECEDENTES = [
  { key: "preNatal", label: "Pre-Natal", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 600 },
  { key: "natal", label: "Natal", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 600 },
  { key: "postNatal", label: "Post-Natal", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 600 },
];

export const CAMPOS_AVD = [
  { key: "vestido", label: "Vestido", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "higiene", label: "Higiene", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "alimentacion", label: "Alimentación", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "controlEsfinteres", label: "Control de esfínteres", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "higieneSueno", label: "Higiene y sueño", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "movilidad", label: "Movilidad", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
];

export const CAMPOS_AVD_INSTRUMENTALES = [
  { key: "tareasHogar", label: "Tareas en el hogar", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 500 },
  { key: "manejoDinero", label: "Manejo de dinero", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 500 },
];

export const CAMPOS_JUEGO = [
  { key: "tipoJuego", label: "Tipo de juego", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 500 },
];

export const CAMPOS_DESEMPENO_ESCOLAR = [
  { key: "participacion", label: "Participación", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 500 },
];

export const CAMPOS_OCIO_TIEMPO_LIBRE = [
  { key: "participacion", label: "Participación", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 500 },
];

export const CAMPOS_COMUNICACION_SOCIAL = [
  { key: "conducta", label: "Conducta", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 500 },
  { key: "interaccionSocial", label: "Interacción social", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 500 },
  { key: "lenguaje", label: "Lenguaje", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 500 },
];

export const CAMPOS_PROCESAMIENTO_SENSORIAL = [
  { key: "visual", label: "Visual", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "tactil", label: "Táctil", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "auditivo", label: "Auditivo", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "gustativo", label: "Gustativo", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "olfativo", label: "Olfativo", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "propioceptivo", label: "Propioceptivo", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "interoceptivo", label: "Interoceptivo", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "vestibular", label: "Vestibular", tipo: TIPO_CAMPO.MULTILINEA, rows: 2, maxLength: 400 },
];

export const CAMPOS_MOTRICIDAD_FINA = [
  { key: "dominancia", label: "Dominancia (Derecha / Izquierda / Aún no integrada)", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "coordinacionBimanual", label: "Coordinación bimanual", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "ojoMano", label: "Ojo-mano", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "ensartar", label: "Ensartar", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "encajar", label: "Encajar", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "enhebrar", label: "Enhebrar", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "bolitas", label: "Realiza bolitas", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "amasaMasilla", label: "Amasa masilla", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "aplastaMasilla", label: "Aplasta masilla", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "cortaMasillaUtensilios", label: "Corta masilla con utensilios", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "rasgarPapel", label: "Rasgar papel", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "coloreoLimites", label: "Coloreo — respeta límites", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "coloreoDireccion", label: "Coloreo — dirección", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "coloreoFuerza", label: "Coloreo — fuerza", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "trazosRectasHV", label: "Trazos rectas H/V", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "trazosZigzag", label: "Trazos zigzag", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "trazosCurvas", label: "Trazos curvas", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "numeros", label: "Números", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "letras", label: "Letras", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "dibujos", label: "Dibujos", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "tijerasRecta", label: "Tijeras — recta", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "tijerasCurvas", label: "Tijeras — curvas", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "tijerasZigzag", label: "Tijeras — zigzag", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "agarreLapiz", label: "Agarre del lápiz", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "fuerzaLapiz", label: "Fuerza (lápiz)", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "observaciones", label: "Observaciones motricidad fina", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 600 },
];

export const CAMPOS_MOTRICIDAD_GRUESA = [
  { key: "coordinacionBilateral", label: "Coordinación bilateral", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "oculomotor", label: "Oculomotor", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "lateralidad", label: "Lateralidad", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "equilibrioEstatica", label: "Equilibrio en estática", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "equilibrioMovimiento", label: "Equilibrio en movimiento", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "equilibrioUnPie", label: "Equilibrio en un pie", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "caminarLineaRecta", label: "Caminar en línea recta", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "saltar", label: "Al saltar", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "saltarUnPie", label: "Al saltar en un pie", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "saltarAmbosPies", label: "Al saltar con ambos pies juntos", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "caminarPuntillas", label: "Caminar en puntillas", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "camina", label: "Camina", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "corre", label: "Corre", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "trepa", label: "Trepa", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "subeEscalerasAlterna", label: "Sube escaleras (alterna pies)", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "subeEscalerasVerticales", label: "Sube escaleras verticales", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "pateaEstatica", label: "Patea pelota en estática", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "pateaMovimiento", label: "Patea pelota en movimiento", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "lanzaAmbasManos", label: "Lanza pelota con ambas manos", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "atrapaAmbasManos", label: "Atrapa pelota con ambas manos", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "lanzaUnaMano", label: "Lanza pelota con una mano", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "atrapaUnaMano", label: "Atrapa pelota con una mano", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "encestaFijo", label: "Encesta en objetivo fijo", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "encestaMovimiento", label: "Encesta en objetivo en movimiento", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "halar", label: "Halar", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "empujar", label: "Empujar", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "fuerza", label: "Fuerza", tipo: TIPO_CAMPO.LINEA, maxLength: 120 },
  { key: "observaciones", label: "Observaciones motricidad gruesa", tipo: TIPO_CAMPO.MULTILINEA, rows: 3, maxLength: 600 },
];

export const CAMPOS_CIERRE = [
  { key: "objetivos", label: "Objetivos", tipo: TIPO_CAMPO.MULTILINEA, rows: 4, maxLength: 800 },
  { key: "recomendaciones", label: "Recomendaciones", tipo: TIPO_CAMPO.MULTILINEA, rows: 4, maxLength: 800 },
  { key: "recibido", label: "Recibido", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
];
